import React from "react";
import "./Why_Choose.css";
import Experience_Change from "./Experience_Change/Experience_Change";
import Why_Choose_card from "./Why_Choose_card/Why_Choose_card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

function Why_Choose() {
  return (
    <>
      <section className="Why_Choose">
        <div className="container">
          <div className="Why_Choose_holder">
            <div className="row">
              <div className="col-md-8 order-md-1 order-2">
                <div className="main-heading-holder">
                  <h4>
                    Why Choose  <br />
                    Videowala Bus Stand?
                  </h4>
                </div>

                <div className="Why_Choose_card_holder">
                  <Swiper
                    slidesPerView={4}
                    spaceBetween={30}
                    pagination={{
                      dynamicBullets: true,
                      clickable: true,
                    }}
                    modules={[Pagination]}
                    className="mySwiper Why_Choose_card_swiper"
                    breakpoints={{
                      0: { slidesPerView: 1, spaceBetween: 30 },
                      321: { slidesPerView: 1, spaceBetween: 30 },
                      485: { slidesPerView: 2, spaceBetween: 30 },
                      576: { slidesPerView: 2, spaceBetween: 30 },
                      765: { slidesPerView: 2, spaceBetween: 30 },
                      992: { slidesPerView: 2, spaceBetween: 30 },
                      1024: { slidesPerView: 2, spaceBetween: 30 },
                      1200: { slidesPerView: 3, spaceBetween: 30 },
                      1400: { slidesPerView: 3, spaceBetween: 30 },
                    }}
                  >
                    <SwiperSlide>
                      <Why_Choose_card
                        imgSrc={
                          "/Assets/Images/Service/Services/Why_Choose/commuting.png"
                        }
                        headingText={"Seamless Commuting"}
                        discriptionText={
                          "Whether you're a daily commuter or an occasional traveler, our system adapts to your needs, ensuring that you're always informed."
                        }
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <Why_Choose_card
                        imgSrc={
                          "/Assets/Images/Service/Services/Why_Choose/idea.png"
                        }
                        headingText={"Smart Technology"}
                        discriptionText={
                          "Leveraging state-of-the-art systems, Videowala Bus Stand sets a new benchmark in modern travel amenities."
                        }
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <Why_Choose_card
                        imgSrc={
                          "/Assets/Images/Service/Services/Why_Choose/time-management.png"
                        }
                        headingText={"Better Time Management"}
                        discriptionText={
                          "With clear information at your fingertips, plan your trip down to the minute without any surprises."
                        }
                      />
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>

              <div className="col-md-4 order-md-2 order-1  mb-mb-0 mb-5">
                <Experience_Change />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Why_Choose;
